/* eslint-disable react/prop-types */
import { useAuth0 } from "@auth0/auth0-react";
import { Text } from "components";
import React from "react";
import "./style.css";

export const SubHeader = ({ color, title, endSection, ...rest }) => {
  const { isAuthenticated } = useAuth0();

  if (!isAuthenticated) return null;

  return (
    <header
      className="d-flex w-100 mt-3 mb-6 "
      {...rest}
      style={{ height: 40 }}
    >
      <div
        className="me-auto mb-3  mt-1 setting-title"
        style={{ marginInlineEnd: "auto" }}
      >
        <Text
          style={{
            color: color,
            fontSize: 24,
            fontWeight: 600,
            FontFace: "Poppins",
            fontStyle: "normal",
          }}
        >
          {title}
        </Text>
      </div>
      {endSection}
    </header>
  );
};
